import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface EditPostPayload {
	id: string;
	body: string;
}

const editPost = async ({ id, body }: EditPostPayload) => {
	const response = await cmsClient.patch(`/social-posts/${id}/`, { body });
	return response.data;
};

const useEditPost = () => {
	const queryClient = useQueryClient();

	return useMutation(editPost, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useEditPost;
